import { create } from 'zustand';

interface TenantState {
  tenantId: number | null;
  empresaNombre: string | null;
}

interface TenantActions {
  setTenant: (tenantId: number, empresaNombre?: string) => void;
  clearTenant: () => void;
}

type TenantStore = TenantState & TenantActions;

const TENANT_ID_KEY = 'tenantId';
const TENANT_NAME_KEY = 'tenantName';

export const useTenantStore = create<TenantStore>((set) => ({
  tenantId: localStorage.getItem(TENANT_ID_KEY) ? Number(localStorage.getItem(TENANT_ID_KEY)) : null,
  empresaNombre: localStorage.getItem(TENANT_NAME_KEY) || null,

  setTenant: (tenantId, empresaNombre) => {
    localStorage.setItem(TENANT_ID_KEY, String(tenantId));
    if (empresaNombre) localStorage.setItem(TENANT_NAME_KEY, empresaNombre);
    set({ tenantId, empresaNombre: empresaNombre ?? null });
  },

  clearTenant: () => {
    localStorage.removeItem(TENANT_ID_KEY);
    localStorage.removeItem(TENANT_NAME_KEY);
    set({ tenantId: null, empresaNombre: null });
  },
}));

